// extracted by mini-css-extract-plugin
module.exports = {"figure":"Img_figure__3Xe0o","img":"Img_img__2eXIa","imgNotFound":"Img_imgNotFound__nOcF3"};